import { render } from "./BaseLoader.vue?vue&type=template&id=7456b682&scoped=true&ts=true"
import script from "./BaseLoader.vue?vue&type=script&lang=ts"
export * from "./BaseLoader.vue?vue&type=script&lang=ts"

import "./BaseLoader.vue?vue&type=style&index=0&id=7456b682&scoped=true&lang=scss"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7456b682"]])

export default __exports__